import gql from 'graphql-tag'

export const SUBSCRIBE_PENDING_RETURN_ORDERS = gql`
subscription Orders{
  pendingReturnOrders:Orders(where: {orderType: {_eq: 3}, status: {_eq: "Pending"}}){
    id
    date
    orderNum
    invoiceNumber
    createdOn
    FromOrganization{
      id
      name
    }
    ToOrganization{
      id
      name
    }    
    PlacedBy{
      id
      name
    }
    OrderItems_aggregate{ aggregate{count} }
  }
}`
export const SUBSCRIBE_APPROVED_RETURN_ORDERS = gql`
subscription Orders{
  approvedReturnOrders:Orders(where: {orderType: {_eq: 3}, status: {_eq: "Accepted"}}){
    id
    date
    orderNum
    invoiceNumber
    createdOn
    FromOrganization{
      id
      name
    }
    ToOrganization{
      id
      name
    }
    PlacedBy{
      id
      name
    }
    OrderItems_aggregate{ aggregate{count} }
  }
}`
export const SUBSCRIBE_REJECTED_RETURN_ORDERS = gql`
subscription Orders{
  rejectedReturnOrders:Orders(where: {orderType: {_eq: 3}, status: {_eq: "Rejected"}}){
    id
    date
    orderNum
    invoiceNumber
    createdOn
    FromOrganization{
      id
      name
    }
    ToOrganization{
      id
      name
    }
    PlacedBy{
      id
      name
    }
    OrderItems_aggregate{ aggregate{count} }
  }
}`

export const SUBSCRIBE_RETURN_ORDERS_TO_ME = gql`
subscription Orders($partnerId:uuid!){
  returnToMeOrders:Orders(where: {to:{_eq:$partnerId},orderType: {_eq: 3}}){
    id
    date
    orderNum
    invoiceNumber
    status
    createdOn
    FromOrganization{
      id
      name
    }
    ToOrganization{
      id
      name
    }
    PlacedBy{
      id
      name
    }
    OrderItems_aggregate{ aggregate{count} }
  }
}`
export const SUBSCRIBE_RETURN_ORDERS_FROM_ME = gql`
subscription Orders($partnerId:uuid!){
  returnFromMeOrders:Orders(where: {from:{_eq:$partnerId}, orderType: {_eq: 3}}){
    id
    date
    orderNum
    invoiceNumber
    status
    createdOn
    FromOrganization{
      id
      name
    }
    ToOrganization{
      id
      name
    }
    PlacedBy{
      id
      name
    }
    OrderItems_aggregate{ aggregate{count} }
  }
}`
